module.exports = __webpack_public_path__ + "1-xmas-snow.39a6dac189c6b7641b31.png";


//////////////////
// WEBPACK FOOTER
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/assets/images/festival/1-xmas-snow.png
// module id = ../../../../../src/assets/images/festival/1-xmas-snow.png
// module chunks = styles